<template>
	<li class="key-feature">
		<div class="bullet">
				<a-check-bullet />
		</div>
		<slot />
	</li>
</template>

<script>
import ACheckBullet from '@/components/a-check-bullet'
export default {
	components: {
		ACheckBullet
	}

}
</script>

<style lang="scss" scoped>
.key-feature {
    list-style: none;
    position: relative;
    margin-bottom: 10px;
    font-size: 1.15em;
    .bullet {
        position: absolute;
        left: -25px;
        top: 0px;
    }
}
</style>
